import AddVan from './AddVan.vue';
import EditVan from './EditVan.vue';
import DeleteVan from './DeleteVan.vue';

export default{
    AddVan,
    EditVan,
    DeleteVan
}